import ApiBase from 'Services/Api/ApiBase';

class Categories extends ApiBase {
    route = '/human-resources/categories';
};

export default new Categories();